// React app intentionally renders nothing.
// The public directory UI is served as a static single-file HTML
// in /app/frontend/public/index.html with /app/frontend/public/data.js.
// The backend (FastAPI) and admin routes still work for backend integrations.
import React from "react";

export default function App() {
  return null;
}
